// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book-section {
    margin-left: 20px;

    margin-top: 20px;

}

.collection-title {
    margin-top: 20px;

    margin-bottom: 15px;

    font-size: 24px;

}

.book-list {
    display: flex;
    flex-direction: column;

    gap: 30px;

}

.book-item {
    display: flex;
    align-items: center;

    transition: background-color 0.3s, transform 0.3s;

}

.book-item:hover {
    background-color: #312f31;
    /* Light background color on hover */
    transform: scale(1.02);
    /* Slightly enlarge the book item */
}

.book-item img {
    width: 70px;
    /* Fixed width for book cover */
    height: auto;
    /* Maintain aspect ratio */
    margin-right: 20px;

}

.book-title {
    font-size: 18px;

    margin: 0;

    line-height: 1.5;

}`, "",{"version":3,"sources":["webpack://./src/components/BookSection.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;;IAEjB,gBAAgB;;AAEpB;;AAEA;IACI,gBAAgB;;IAEhB,mBAAmB;;IAEnB,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,sBAAsB;;IAEtB,SAAS;;AAEb;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,iDAAiD;;AAErD;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;;IAEf,SAAS;;IAET,gBAAgB;;AAEpB","sourcesContent":[".book-section {\n    margin-left: 20px;\n\n    margin-top: 20px;\n\n}\n\n.collection-title {\n    margin-top: 20px;\n\n    margin-bottom: 15px;\n\n    font-size: 24px;\n\n}\n\n.book-list {\n    display: flex;\n    flex-direction: column;\n\n    gap: 30px;\n\n}\n\n.book-item {\n    display: flex;\n    align-items: center;\n\n    transition: background-color 0.3s, transform 0.3s;\n\n}\n\n.book-item:hover {\n    background-color: #312f31;\n    /* Light background color on hover */\n    transform: scale(1.02);\n    /* Slightly enlarge the book item */\n}\n\n.book-item img {\n    width: 70px;\n    /* Fixed width for book cover */\n    height: auto;\n    /* Maintain aspect ratio */\n    margin-right: 20px;\n\n}\n\n.book-title {\n    font-size: 18px;\n\n    margin: 0;\n\n    line-height: 1.5;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
